/* ==========================================================================
   Spicy Cubes Landing — behaviour
   Self-initialises every .scl-root on the page. Reads its configuration from
   data-attributes so the section file stays markup-only.
   ========================================================================== */
(function () {
  'use strict';

  /* Every scl-XX section on the landing page renders the shared
     'scl-assets' snippet, which emits its own <script src="...
     spicy-cubes-landing.js"> tag — so on a page with N sections this whole
     IIFE actually executes N times. Each execution used to create its own
     independent lightbox overlay + its own document-level click listeners,
     so opening a review photo stacked N identical full-screen overlays and
     the "×" button only ever closed the top one, leaving the rest visible
     underneath — the image never appeared to close. Guard so only the
     first execution on the page runs; later re-executions are a no-op. */
  if (window.__sclLandingLoaded) return;
  window.__sclLandingLoaded = true;

  function money(el) { return el ? el.textContent.trim() : ''; }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- review photo lightbox ----------
     Global and page-wide (not per-.scl-root, not re-run by init()): a click on
     any [data-scl-photo-zoom] button (the customer-photo strip rendered by
     scl-10-testimonials.liquid) opens that photo full-size. One shared
     overlay is created lazily on first use and reused for every click. */
  var sclLightboxEl = null;

  function sclCloseLightbox() {
    if (sclLightboxEl) sclLightboxEl.classList.remove('is-open');
    document.body.classList.remove('scl-lightbox-open');
  }

  function sclOpenLightbox(src, alt) {
    if (!src) return;
    if (!sclLightboxEl) {
      sclLightboxEl = document.createElement('div');
      sclLightboxEl.className = 'scl-lightbox';
      sclLightboxEl.setAttribute('data-scl-lightbox', '');
      sclLightboxEl.innerHTML =
        '<button type="button" class="scl-lightbox__close" aria-label="Đóng">&times;</button>' +
        '<img class="scl-lightbox__img" alt="">';
      document.body.appendChild(sclLightboxEl);
      sclLightboxEl.addEventListener('click', function (e) {
        if (e.target === sclLightboxEl || e.target.closest('.scl-lightbox__close')) {
          sclCloseLightbox();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') sclCloseLightbox();
      });
    }
    var img = sclLightboxEl.querySelector('.scl-lightbox__img');
    img.src = src;
    img.alt = alt || '';
    sclLightboxEl.classList.add('is-open');
    document.body.classList.add('scl-lightbox-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scl-photo-zoom]');
    if (!trigger) return;
    e.preventDefault();
    var img = trigger.querySelector('img');
    sclOpenLightbox(trigger.getAttribute('data-full'), img ? img.alt : '');
  });

  function init(root) {
    if (!root || root.dataset.sclInit === '1') return;
    root.dataset.sclInit = '1';

    var sectionId  = root.dataset.sectionId || '';
    var variantId  = root.dataset.variantId || '';
    var cartAction = root.dataset.cartAction || 'checkout';
    var atcLabel   = root.dataset.atcLabel || 'Add to cart';
    /* split into separate sections: the offer block lives in another section */
    var offer      = document.querySelector('[data-scl-offer]') || root.querySelector('[data-scl-offer]');
    var errEl      = root.querySelector('[data-scl-err]');

    /* ---------- CTAs scroll to the offer block ---------- */

    /**
     * Resolved on every click rather than once at init.
     * The offer block lives in a different section, so a reference captured
     * during init points at a detached node as soon as that section is
     * re-rendered in the theme editor — which silently killed every CTA on
     * the page until a full reload. Falls back through looser selectors so a
     * missing marker degrades to "scrolls to the offer section" instead of
     * "the button does nothing".
     */
    function findOffer() {
      return document.querySelector('[data-scl-offer]')
        || document.querySelector('.scl-pdp')
        || document.querySelector('[id^="shopify-section"][id*="offer"]');
    }

    root.querySelectorAll('[data-scl-scroll]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var target = findOffer();
        if (!target) return;

        /* no-op on <button type="button">; keeps this correct if the CTA is
           ever changed to a real <a href="#..."> anchor */
        if (e && typeof e.preventDefault === 'function') e.preventDefault();

        /**
         * scrollIntoView, NOT window.scrollTo.
         *
         * window.scrollTo only moves the document's own scrolling box, so it
         * silently does nothing whenever some ancestor wrapper owns the
         * scroll instead (a `.page-wrapper` with overflow-x:hidden is the
         * usual culprit, and it is typically applied at desktop widths only —
         * which is exactly why these buttons died on desktop but kept working
         * on mobile). scrollIntoView walks up and scrolls whichever box is
         * actually scrollable, so it is correct in both cases.
         *
         * It also honours the `scroll-margin-top:90px` already declared on
         * .scl-pdp in spicy-cubes-landing.css — that property is inert under
         * window.scrollTo, which is why the sticky-header clearance the
         * stylesheet was written for never took effect.
         */
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
          /* older Safari: no options object */
          target.scrollIntoView(true);
        }

        if (target.id && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + target.id);
        }
      });
    });

    /* ---------- review carousel ---------- */
    var track = root.querySelector('[data-scl-track]');
    var dotsWrap = root.querySelector('[data-scl-dots]');
    if (track && dotsWrap) {
      var dots = dotsWrap.children;
      track.addEventListener('scroll', function () {
        var cards = track.children;
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0, min = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var cc = cards[i].offsetLeft + cards[i].clientWidth / 2;
          var d = Math.abs(cc - center);
          if (d < min) { min = d; closest = i; }
        }
        for (var j = 0; j < dots.length; j++) dots[j].classList.remove('is-active');
        if (dots[closest]) dots[closest].classList.add('is-active');
      }, { passive: true });

      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.addEventListener('click', function () {
          var card = track.children[i];
          if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    /* ---------- product gallery ---------- */
    var thumbs = root.querySelector('[data-scl-thumbs]');
    var mainImg = root.querySelector('[data-scl-main-img]');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('.scl-pdp__thumb');
        if (!t) return;
        thumbs.querySelectorAll('.scl-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (t.dataset.full) mainImg.src = t.dataset.full;
      });
    }

    /* ---------- bundle selection ---------- */
    var radios = sectionId
      ? root.querySelectorAll('input[name="scl-bundle-' + sectionId + '"]')
      : root.querySelectorAll('.scl-bundle input[type="radio"]');
    var atcBtns = root.querySelectorAll('[data-scl-atc]');
    var stickyPrice = root.querySelector('[data-scl-sticky-price]');
    var mainAtc = root.querySelector('.scl-atc');

    function selected() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return radios[0] || null;
    }

    function paint() {
      var r = selected();
      if (!r) return;
      if (mainAtc && !mainAtc.disabled) mainAtc.textContent = atcLabel + ' - ' + r.dataset.price;
      if (stickyPrice) {
        stickyPrice.textContent = '';
        var span = document.createElement('span');
        span.textContent = r.dataset.price;
        stickyPrice.appendChild(span);
        if (r.dataset.compare) {
          var s = document.createElement('s');
          s.textContent = r.dataset.compare;
          stickyPrice.appendChild(s);
        }
      }
    }
    Array.prototype.forEach.call(radios, function (r) { r.addEventListener('change', paint); });
    paint();

    /* ---------- add to cart ---------- */
    function showErr(msg) {
      if (!errEl) { window.alert(msg); return; }
      errEl.textContent = msg;
      errEl.classList.add('is-shown');
    }

    function addToCart() {
      if (!variantId) { showErr('No product is selected for this section.'); return; }
      var r = selected();
      var qty = r ? (parseInt(r.dataset.qty, 10) || 1) : 1;
      var code = r ? (r.dataset.discount || '').trim() : '';
      var base = routeRoot();

      if (errEl) errEl.classList.remove('is-shown');
      Array.prototype.forEach.call(atcBtns, function (b) { b.disabled = true; });

      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      })
        .then(function (res) {
          return res.json().then(function (d) { return { ok: res.ok, data: d }; });
        })
        .then(function (out) {
          if (!out.ok) {
            throw new Error((out.data && (out.data.description || out.data.message)) || 'Could not add to cart.');
          }
          var dest = cartAction === 'cart' ? base + 'cart' : '/checkout';
          window.location.href = code
            ? base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest)
            : dest;
        })
        .catch(function (err) {
          Array.prototype.forEach.call(atcBtns, function (b) { b.disabled = false; });
          showErr(err.message || 'Could not add to cart. Please try again.');
        });
    }
    Array.prototype.forEach.call(atcBtns, function (b) { b.addEventListener('click', addToCart); });

    /* ---------- tabs ---------- */
    root.querySelectorAll('[data-scl-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-scl-tab');
        root.querySelectorAll('[data-scl-tab]').forEach(function (b) { b.classList.remove('is-active'); });
        root.querySelectorAll('[data-scl-panel]').forEach(function (pn) { pn.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = root.querySelector('[data-scl-panel="' + i + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    /* ---------- faq ---------- */
    root.querySelectorAll('[data-scl-faq]').forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.parentElement.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- testimonials show more ----------
       Paginated reveal: starts with the first batch already visible
       (kept in sync with the `forloop.index > 6` cut-off rendered server-side
       in scl-10-testimonials.liquid), then each click reveals the NEXT batch
       of cards rather than unhiding everything at once. Once every card is
       showing, the button flips to the "less" label and a further click
       collapses back to the first batch. */
    var moreBtn = root.querySelector('[data-scl-more]');
    var crevGrid = root.querySelector('[data-scl-crev]');
    if (moreBtn && crevGrid) {
      var crevBatch = 6;
      var crevCards = crevGrid.querySelectorAll('.scl-crev__card');
      var crevTotal = crevCards.length;
      var crevShown = Math.min(crevBatch, crevTotal);

      moreBtn.addEventListener('click', function () {
        var fullyOpen = crevGrid.dataset.open === 'true';
        crevShown = fullyOpen ? Math.min(crevBatch, crevTotal) : Math.min(crevShown + crevBatch, crevTotal);

        Array.prototype.forEach.call(crevCards, function (c, i) {
          c.classList.toggle('is-hidden', i >= crevShown);
        });

        var nowFullyOpen = crevShown >= crevTotal;
        crevGrid.dataset.open = nowFullyOpen ? 'true' : 'false';
        moreBtn.textContent = nowFullyOpen ? moreBtn.dataset.less : moreBtn.dataset.more;
      });
    }

    /* ---------- review photos: drag-to-scroll with mouse ----------
       overflow-x:auto already gives touch/trackpad swipe and scrollbar-drag,
       but a plain desktop mouse has no built-in way to pan a horizontally
       scrolling flex strip by holding the button and dragging — so without
       this the customer-photo strip never moved for a mouse user. */
    var photosStrip = root.querySelector('.scl-crev__photos');
    if (photosStrip) {
      /* arrow buttons: click to scroll the strip sideways one "page" at a
         time (added alongside the existing mouse drag-to-scroll below) */
      var photosWrap = photosStrip.closest('.scl-crev__photos-wrap');
      var photoPrevBtn = photosWrap && photosWrap.querySelector('[data-scl-photo-prev]');
      var photoNextBtn = photosWrap && photosWrap.querySelector('[data-scl-photo-next]');

      function getPhotoScrollAmount() {
        return Math.max(photosStrip.clientWidth * 0.9, 150);
      }
      function updatePhotoArrows() {
        if (!photoPrevBtn && !photoNextBtn) return;
        var maxScroll = photosStrip.scrollWidth - photosStrip.clientWidth;
        if (photoPrevBtn) photoPrevBtn.classList.toggle('is-disabled', photosStrip.scrollLeft <= 2);
        if (photoNextBtn) photoNextBtn.classList.toggle('is-disabled', photosStrip.scrollLeft >= maxScroll - 2);
      }
      if (photoPrevBtn) {
        photoPrevBtn.addEventListener('click', function () {
          photosStrip.scrollBy({ left: -getPhotoScrollAmount(), behavior: 'smooth' });
        });
      }
      if (photoNextBtn) {
        photoNextBtn.addEventListener('click', function () {
          photosStrip.scrollBy({ left: getPhotoScrollAmount(), behavior: 'smooth' });
        });
      }
      photosStrip.addEventListener('scroll', updatePhotoArrows, { passive: true });
      window.addEventListener('resize', updatePhotoArrows);
      updatePhotoArrows();

      var sclDragging = false, sclDragMoved = false, sclDragStartX = 0, sclDragStartScroll = 0;

      photosStrip.addEventListener('mousedown', function (e) {
        sclDragging = true;
        sclDragMoved = false;
        sclDragStartX = e.pageX;
        sclDragStartScroll = photosStrip.scrollLeft;
        photosStrip.classList.add('is-dragging');
        e.preventDefault(); /* stop native image/text drag ghost */
      });

      window.addEventListener('mousemove', function (e) {
        if (!sclDragging) return;
        var dx = e.pageX - sclDragStartX;
        if (Math.abs(dx) > 4) sclDragMoved = true;
        photosStrip.scrollLeft = sclDragStartScroll - dx;
      });

      function sclEndPhotoDrag() {
        if (!sclDragging) return;
        sclDragging = false;
        photosStrip.classList.remove('is-dragging');
      }
      window.addEventListener('mouseup', sclEndPhotoDrag);
      photosStrip.addEventListener('mouseleave', function () {
        if (sclDragging) sclEndPhotoDrag();
      });

      /* a drag that actually moved shouldn't also trigger the photo's
         click-to-zoom lightbox */
      photosStrip.addEventListener('click', function (e) {
        if (sclDragMoved) {
          e.preventDefault();
          e.stopPropagation();
          sclDragMoved = false;
        }
      }, true);
    }

    /* ---------- sticky mobile bar ---------- */
    var sticky = root.querySelector('[data-scl-sticky]');
    if (sticky && offer && 'IntersectionObserver' in window) {
      var hero = document.querySelector('.scl-hero');
      var offerVisible = false;
      var pastHero = false;

      var sync = function () {
        var show = pastHero && !offerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };

      new IntersectionObserver(function (entries) {
        offerVisible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(offer);

      if (hero) {
        new IntersectionObserver(function (entries) {
          pastHero = !entries[0].isIntersecting;
          sync();
        }, { threshold: 0 }).observe(hero);
      }
    }
  }

  function boot() {
    document.querySelectorAll('.scl-root').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.scl-root');
    if (r) { r.dataset.sclInit = ''; init(r); }
  });
})();
